import React, { Component } from 'react';
import '../../App.css';
import Slider from "react-slick";
import FlipPage from 'react-flip-page'

import Footer from '../reusables/footer'

import BananoThumb from '../../img/pioricost-fruit/banano/banano1.jpeg'

import Banano2 from '../../img/pioricost-fruit/banano/banano2.jpeg'
import Banano4 from '../../img/pioricost-fruit/banano/banano4.jpeg'
import Banano5 from '../../img/pioricost-fruit/banano/banano5.jpeg'

import Pit1 from '../../img/pioricost-fruit/pitahaya/pit1.jpeg'
import Pit2 from '../../img/pioricost-fruit/pitahaya/pit2.jpeg'
import Pit3 from '../../img/pioricost-fruit/pitahaya/pit3.jpeg'
import Pit4 from '../../img/pioricost-fruit/pitahaya/pit4.jpeg'

import Cacao1 from '../../img/pioricost-fruit/cacao/cacao1.jpeg'
import Cacao2 from '../../img/pioricost-fruit/cacao/cacao2.jpeg'
import Cacao3 from '../../img/pioricost-fruit/cacao/cacao3.jpeg'
import Cacao4 from '../../img/pioricost-fruit/cacao/cacao4.jpeg'

import cert1 from '../../img/pioricost-fruit/certificaciones/1.jpg'
import cert2 from '../../img/pioricost-fruit/certificaciones/2.png'
import cert3 from '../../img/pioricost-fruit/certificaciones/3.png'
import cert4 from '../../img/pioricost-fruit/certificaciones/4.png'

import revista1 from '../../img/magazine/1.jpg'
import revista2 from '../../img/magazine/2.jpg'
import revista3 from '../../img/magazine/3.jpg'
import revista4 from '../../img/magazine/4.jpg'
import revista5 from '../../img/magazine/5.jpg'
import revista6 from '../../img/magazine/6.jpg'
import revista7 from '../../img/magazine/7.jpg'
import revista8 from '../../img/magazine/8.jpg'

import flipSound from '../../audio/flip.mp3'

class Fruit extends Component {
    constructor(){
        super()
        this.state = {
            showItem : 1,
            widthMagazine: 600,
            heightMagazine: 800
        }
    }

    componentDidMount(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            // console.log("este es un smartphone")
            this.setState ({ widthMagazine: 380 })
            this.setState ({ heightMagazine: 510 })
         } else {
            this.setState ({ widthMagazine: 600 })
            this.setState ({ heightMagazine: 800 })
         }
    }

    showCaja=(producto)=>{
        this.setState({
            showItem: this.state.showItem ? 0 : producto
        })
    }
    
  render() {
      var settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        arrows: false
      }
    return (
      <div className="Fruit">
        <br/><br/><br/>
        <br/><br/><br/>
        <br/><br/><br/>
            <div className="magazine">
            <audio id="audioContainer" volume="0.2">
              <source src={flipSound} type="audio/mp3"/>
            </audio>
            <FlipPage width={this.state.widthMagazine} height={this.state.heightMagazine} orientation="horizontal"
                        onPageChange={()=>{document.getElementById("audioContainer").play()}} >
                <img src={revista1} />
                <img src={revista2} />
                <img src={revista3} />
                <img src={revista4} />
                <img src={revista5} />
                <img src={revista6} />
                <img src={revista7} />
                <img src={revista8} />
            </FlipPage>
            </div>
            <div className="main-container-product" id="">
                <div className="slider-product-container">
                <Slider {...settings}>
                    <div>
                    <img src={BananoThumb} alt=""/>
                    </div>
                    <div>
                    <img src={Banano2} alt=""/>
                    </div>
                    <div>
                    <img src={Banano4} alt=""/>
                    </div>
                    <div>
                    <img src={Banano5} alt=""/>
                    </div>
                </Slider>                       
                </div>
                <div className="info-product">
                    <span>БАНАН</span><hr/>
                    <p>
                        <b>ОПИСАНИЕ</b><br/><br/>
                        <b>Длина пальцев:</b> минимум 18 см<br/>
                        <b>Толщина:</b> минимум 39 мм, максимум 47 мм<br/>
                        <b>Категория:</b> "А" Премиум<br/>
                        <b>Возраст плода:</b> минимум 10 недель и максимум 13 недель
                        <br/><br/>
                        <b>ПЕРИОД СБОРА УРОЖАЯ</b><br/><br/>
                        Весь год<br/><br/>

                        <b>УПАКОВКА</b><br/><br/>
                        <b>Тип коробки 208 (Азия)</b><br/>
                        <b>Длина пальцев:</b> минимум 18 см<br/>
                        <b>Количество пальцев на руку:</b> минимум 15<br/>
                        <b>Толщина:</b> минимум 39 мм, максимум 47 мм<br/>
                        <b>Возраст плода:</b> минимум 10 недель и максимум 13 недель. Коробка: типы коробок 208 (бес 13,6 кг), коробка в руках, 1500 коробок в контейнере для грузов. <br/>
                        <b>Упаковка:</b> крышка, дно, внешний бристольский картон внутренний бристольский картон, защитная пленка для рук и вакуумная крышка или полиэтилен.<br/><br/>


                        <b>Тип коробки 22XU (Европа и США)</b><br/><br/>
                        <b>Длина пальцев:</b> минимум 18 см<br/>
                        <b>Толщина:</b> мин. 39 мм Макс. 46 мм.<br/>
                        <b>Количество пальцев на руку:</b> минимум от 5 до 12 пальцев<br/>
                        <b>Ящик:</b> Типы Ящиков 22XU (нетто 18,14 кг или 19,45 кг) от 960 до 1,080 ящиков в контейнере поддонов.<br/>
                        <b>Упаковка:</b> крышка, дно, картон и вакуумная крышка или полипакет.<br/>
                    </p>
                </div>
            </div>
            <div className="valor-nutricional">
                <span>ПИЩЕВАЯ <b>ЦЕННОСТЬ</b></span><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Калории </label>
                        <span>110,5 ккал</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин B6</label>
                        <span>0,68 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Гидраты<br/> Угли</label>
                        <span>26,2 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Калий </label>
                        <span>467 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Жиры </label>
                        <span>-1 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Белки </label>
                        <span>1,2 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин C</label>
                        <span>18 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Волокно<br/> Продовольственная</label>
                        <span>2,6 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Фосфор </label>
                        <span>38,7 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>магний</label>
                        <span>41,5 мг</span>
                    </div>
                </div>
            </div>        
        {/* } */}
        
        <br/><br/><br/>
        {/* {this.state.showItem === 2 && */}
            <div className="main-container-product" id="">
            <div className="slider-product-container">
            <Slider {...settings}>
                <div>
                <img src={Pit1} alt=""/>
                </div>
                <div>
                <img src={Pit2} alt=""/>
                </div>
                <div>
                <img src={Pit3} alt=""/>
                </div>
                <div>
                <img src={Pit4} alt=""/>
                </div>
            </Slider>                       
            </div>
            <div className="info-product">
                <span>ПИТАХАЙЯ</span><hr/>
                <p>
                    <b>ОПИСАНИЕ</b><br/><br/>
                    Плод является яйцевидной формой, удлиненной с диаметром от 10 до 15 см , имеет желтоватую кожуру, мякоть белая с многочисленными мелкими черными семенами, его вес колеблется от 350 г до 450 г.
                    <br/><br/>
                    <b>ПЕРИОД УРОЖАЯ</b><br/><br/>
                    У Питахайи есть три важных периодов урожая:<br/>
                    • с декабря по март<br/>
                    • с октября по ноябрь<br/>
                    • с мая по июнь<br/>
                    <br/><br/>

                    <b>УПАКОВКА</b><br/><br/>
                    Свежие фрукты упаковывается в картонные ящики, в которых указано количество единиц и вес нетто. Каждый ящик содержит от 5 до 7 единиц фруктов, вес нетто 2,5 кг.<br/>
                </p>
            </div>
        </div>
        <div className="valor-nutricional">
                <span>ПИЩЕВАЯ <b>ЦЕННОСТЬ</b></span><br/><br/>
                <label>Желтая Питахайя</label><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Энергетическая ценность</label>
                        <span>54 ккал</span>
                    </div>
                    <div className="cuadro">
                        <label>Жир</label>
                        <span>0,4 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Углеводы</label>
                        <span>15 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Белок </label>
                        <span>1,2 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Сырое волокно</label>
                        <span>0,8 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Фосфор</label>
                        <span>16 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин А</label>
                        <span>5 УГ</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин С</label>
                        <span>8 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Ниацин</label>
                        <span>0,36 мг</span>
                    </div>
                </div>
            </div>   
            <div className="valor-nutricional"><br/>
                {/* <span>VALOR <b>NUTRICIONAL</b></span><br/> */}
                <label>Питахая Обитель</label><br/><br/>
                <div className="cuadros-vn">
                <div className="cuadro">
                        <label>Энергетическая ценность</label>
                        <span>54 ккал</span>
                    </div>
                    <div className="cuadro">
                        <label>Жир</label>
                        <span>0,4 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Углеводы </label>
                        <span>10 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Белок </label>
                        <span>1,5 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Сырое волокно</label>
                        <span>0,6 г</span>
                    </div>
                    <div className="cuadro">
                        <label>Фосфор</label>
                        <span>26 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин А</label>
                        <span>5 УГ</span>
                    </div>
                    <div className="cuadro">
                        <label>Витамин С</label>
                        <span>25 мг</span>
                    </div>
                    <div className="cuadro">
                        <label>Ниацин</label>
                        <span>0,36 мг</span>
                    </div>
                </div>
            </div>             
        {/* } */}
        <br/><br/><br/>
        {/* {this.state.showItem === 3 && */}
            <div className="main-container-product" id="">
            <div className="slider-product-container">
            <Slider {...settings}>
                <div>
                <img src={Cacao1} alt=""/>
                </div>
                <div>
                <img src={Cacao2} alt=""/>
                </div>
                <div>
                <img src={Cacao3} alt=""/>
                </div>
                <div>
                <img src={Cacao4} alt=""/>
                </div>
            </Slider>                       
            </div>
            <div className="info-product">
                <span>CACAO</span><hr/>
                <p>
                    <table>
                        <tr>
                            <th>REQUISITOS</th>
                            <th>UNIDAD</th>
                            <th>CCN-51</th>
                            <th>ASE</th>
                            <th>ASN</th>
                            <th>ASS</th>
                            <th>ASSS</th>
                            <th>ASSPS</th>
                        </tr>
                        <tr>
                            <td>100 Granos<br/>Pesan</td>
                            <td>gr</td>
                            <td>135 - 140</td>
                            <td>105 - 110</td>
                            <td>110 - 115</td>
                            <td>120 - 125</td>
                            <td>130 - 135</td>
                            <td>135 - 140</td>
                        </tr>
                        <tr>
                            <td>Buena Fermentación<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>65</td>
                            <td>26</td>
                            <td>44</td>
                            <td>60</td>
                            <td>65</td>
                            <td>75</td>
                        </tr>
                        <tr>
                            <td>Ligera Fermentación<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>11</td>
                            <td>27</td>
                            <td>10</td>
                            <td>5</td>
                            <td>10</td>
                            <td>10</td>
                        </tr>
                        <tr>
                            <td>Total Fermentado<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>76</td>
                            <td>53</td>
                            <td>54</td>
                            <td>65</td>
                            <td>75</td>
                            <td>85</td>
                        </tr>
                        <tr>
                            <td>Violeta (Máximo)</td>
                            <td>%</td>
                            <td>18</td>
                            <td>25</td>
                            <td>25</td>
                            <td>21</td>
                            <td>15</td>
                            <td>10</td>
                        </tr>
                        <tr>
                            <td>Pizarroso / Pastoso<br/>(Máximo)</td>
                            <td>%</td>
                            <td>5</td>
                            <td>18</td>
                            <td>18</td>
                            <td>12</td>
                            <td>9</td>
                            <td>4</td>
                        </tr>
                        <tr>
                            <td>Moho (Máximo)</td>
                            <td>%</td>
                            <td>1</td>
                            <td>4</td>
                            <td>3</td>
                            <td>2</td>
                            <td>1</td>
                            <td>1</td>
                        </tr>
                        <tr>
                            <td>Totales (Análisis<br/>sobre 100 pepas)</td>
                            <td>%</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                        </tr>
                        <tr>
                            <td>Defectuoso (Máximo)<br/>(Análisis sobre 500gr)</td>
                            <td>%</td>
                            <td>1</td>
                            <td>4</td>
                            <td>3</td>
                            <td>1</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                    </table><br/>
                    ASSPS: Arriba Superior Summer Plantación Selecta<br/>
                    ASSS: Arriba Superior Summer Selecto<br/>
                    ASS: Arriba Superior Selecto<br/>
                    ASN: Arriba Superior Navidad<br/>
                    ASE: Arriba Superior Época<br/>
                </p>
            </div>
        </div>    
        <div className="valor-nutricional">
                <span>VALOR <b>NUTRICIONAL</b></span><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Calorías</label>
                        <span>500</span>
                    </div>
                    <div className="cuadro">
                        <label>Carbohidratos</label>
                        <span>45 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fibra</label>
                        <span>2 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Grasas</label>
                        <span>30 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Proteínas</label>
                        <span>9 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina A</label>
                        <span>150 UI</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina C</label>
                        <span>10 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina E</label>
                        <span>0,5 mg</span>
                    </div>
                </div>
            </div>           
        {/* } */}
        <br/><br/><br/><br/><br/><br/><br/>
        <div className="logos-cert">
            <span>CERTIFICACIONES</span><br/>
            {/* <img src={cert1} alt=""/> */}
            <img src={cert2} alt=""/>
            {/* <img src={cert3} alt=""/>
            <img src={cert4} alt=""/> */}
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Fruit;


// WEBPACK FOOTER //
// ./src/components/ru-fruit/index.js